import { useTranslation } from 'react-i18next'

export default function MyTrainingDetailsCard({ training, statusLabel, createdDate }) {
	const { t } = useTranslation()

	return (
		<div className="mb-5 rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
				<div>
					<h1 className="text-lg font-semibold text-gray-900">{training?.nazwa || '—'}</h1>
					<p className="mt-1 text-sm text-gray-600">{training?.placowkaName || '—'}</p>
					<p className="mt-1 text-sm text-gray-500">{training?.placowkaAddress || '—'}</p>
				</div>
			</div>

			<dl className="mt-4 grid grid-cols-1 gap-3 border-t border-gray-100 pt-4 text-sm sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.add.placowkaLabel')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaName || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.list.table.voivodeship')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaWojewodztwo || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.city')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaMiasto || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.gmina')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaGmina || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.powiat')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaPowiat || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('placowkaPicker.table.type')}</dt>
					<dd className="mt-0.5 text-gray-900">{training?.placowkaTyp || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.form.fields.status')}</dt>
					<dd className="mt-0.5 text-gray-900">{statusLabel || '—'}</dd>
				</div>
				<div>
					<dt className="text-xs font-medium uppercase tracking-wide text-gray-500">{t('trainings.details.fields.created')}</dt>
					<dd className="mt-0.5 text-gray-900">{createdDate || '—'}</dd>
				</div>
			</dl>
		</div>
	)
}
